import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import SnackBar from '../SnackBar';

const propTypes = {
  disconnected: PropTypes.bool.isRequired,
  children: PropTypes.node,
};

const ConnectivitySnackBar = ({ disconnected, children }) => {
  if (disconnected) {
    return <SnackBar>{children}</SnackBar>;
  }

  return null;
};

ConnectivitySnackBar.propTypes = propTypes;
ConnectivitySnackBar.defaultProps = {
  children: (
    <FormattedMessage
      id="connection_snackbar.disconnect_message"
      defaultMessage="Connection lost. Reconnecting..."
    />
  ),
};

export default ConnectivitySnackBar;



// WEBPACK FOOTER //
// ../ui-components/components/ConnectivitySnackBarLayout/index.jsx